<app-main-header [name_main]="'Reglas de schema'">
  <button class="check-btn" mat-flat-button color="primary" routerLink="/schema-rules/create">
    CREAR
  </button>
  <button [disabled]="!selectedItems.length" class="check-btn delete-btn" mat-flat-button color="warn"
    (click)="deleteSelectedRules()">
    BORRAR
  </button>
</app-main-header>

@if (isLoading) {
  <section class="schema-rules-page">
    <div class="status-box">Cargando reglas...</div>
  </section>
} @else {
  <app-data-table
    [data]="rules"
    [columns]="columns"
    [rows]="50"
    [rowsPerPageOptions]="[10, 25, 50]"
    [selection]="selectedItems"
    [sortField]="'rule'"
    [sortOrder]="1"
    [showFilters]="true"
    (selectionChange)="onSelectionChange($event)"
    (editItem)="onEditRule($event)"
    (deleteItems)="onDeleteFromTable($event)">
  </app-data-table>
}
